import React, { useState, useCallback } from "react";
import { useT } from "@transifex/react";
import { RendererProps } from "./index";
import { SelectWrapper } from "./renderer-styles";

const SelectInputRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const t = useT();
  const [value, setValue] = useState<string>(answer?.value ?? "");
  const choices = question.choices || question.options || [];

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const val = e.target.value;
      setValue(val);
      onAnswer(val, val !== "");
    },
    [onAnswer]
  );

  return (
    <SelectWrapper value={value} onChange={handleChange}>
      <option value="">{t("Select an option…")}</option>
      {choices.map((choice) => (
        <option key={choice.value} value={choice.value}>
          {choice.title || choice.label}
        </option>
      ))}
    </SelectWrapper>
  );
};

export default SelectInputRenderer;
